module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-00.2@2x.29167f42.jpg";